import styled from 'styled-components';

export const Page = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
`;

export const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const BackButton = styled.button`
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 16px;
  color: #333;
  
  &:hover {
    background: #e8e8e8;
  }
`;

export const Header = styled.div`
  margin-bottom: 20px;
  
  h1 {
    margin: 0 0 8px 0;
    font-size: 24px;
    font-weight: 600;
    color: #333;
  }
`;

export const Subtitle = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;

export const Controls = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const ControlRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
  }
  
  select, input[type="text"], input[type="number"] {
    padding: 6px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }
  
  button {
    padding: 8px 16px;
    background: #0066cc;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    
    &:hover {
      background: #0052a3;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;

export const CheckboxLabel = styled.label`
  cursor: pointer;
  user-select: none;
  
  input[type="checkbox"] {
    margin-right: 6px;
    cursor: pointer;
  }
`;

export const StatusButton = styled.button`
  margin-left: 8px;
  font-size: 13px;
  padding: 6px 12px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background: #555;
  }
  
  &:active {
    background: #444;
  }
`;

export const Meta = styled.div`
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
`;

export const Error = styled.div`
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  padding: 12px;
  color: #c00;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const LogsContainer = styled.div`
  background: #1e1e1e;
  border-radius: 8px;
  padding: 16px;
  max-height: 600px;
  overflow-y: auto;
  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
`;

export const LogLine = styled.div<{ isPass?: boolean; isFail?: boolean; isCritical?: boolean }>`
  color: ${props => props.isCritical ? '#f44336' : props.isFail ? '#ff9800' : props.isPass ? '#4caf50' : '#ddd'};
  font-weight: ${props => props.isCritical ? 'bold' : 'normal'};
  white-space: pre-wrap;
  word-break: break-all;
  margin-bottom: 2px;
`;

export const Empty = styled.div`
  color: #999;
  text-align: center;
  padding: 40px 20px;
  font-style: italic;
  
  code {
    background: #2a2a2a;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 11px;
    color: #4caf50;
  }
`;

